var map = {
	"./CCB.svg": "94f3",
	"./admin.svg": "ced6",
	"./advert.svg": "e20f",
	"./building.svg": "8c51",
	"./content.svg": "33c4",
	"./coupon.svg": "e24d",
	"./cupboard.svg": "6f71",
	"./data.svg": "5a0a",
	"./distribute.svg": "3b2f",
	"./example.svg": "30c3",
	"./eye.svg": "4df5",
	"./finance.svg": "b599",
	"./form.svg": "eb1b",
	"./goods.svg": "7421",
	"./link.svg": "18f0",
	"./log.svg": "fea0",
	"./member.svg": "daf4",
	"./nested.svg": "dcf8",
	"./order.svg": "11ff",
	"./others.svg": "3756",
	"./password.svg": "2a3d",
	"./sendman.svg": "ae15",
	"./shop.svg": "5def",
	"./site.svg": "c99e",
	"./staff.svg": "d46f",
	"./system.svg": "30a9",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./users.svg": "5055",
	"./wallet.svg": "402b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";